/** @format */

import * as actionTypes from 'stateContainer/action-types';

const initialState = {
  show: false
};

export const stepperReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_STEPPER_MOBILE:
      return { ...state, show: action.payload };

    default:
      return state;
  }
};
